const ProductSlider = {
  options: {
    data: {
      images: [
        {
          image: {
            src: '',
          },
          pointTo: {
            url: '',
            pointTo: '',
            pointToName: '',
            pointToType: '',
          },
        },
      ],
      dynamicImages: [
        {
          image: {
            src: '',
          },
          pointTo: {
            url: '',
            pointTo: '',
            pointToName: '',
            pointToType: '',
          },
        },
      ],
      isDynamic: false,
    },
    customization: {},
    widgets: {
      Menu_TitleSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'titleSettings',
        },
        options: {
          text: {
            type: 'Text',
            order: 0,
          },
          textColor: {
            type: 'HexColor',
            order: 1,
          },
          textAlignment: {
            type: 'LeftCenterRight',
            order: 2,
          },
          textStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          textWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          textLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
        },
      },
      Menu_ProductImageSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'ProductImageSettings',
        },
        options: {
          backgroundSize: {
            type: 'Radio',
            order: 7,
            data: {
              direction: 'row',
              radioOptions: ['cover', 'contain', 'stretch'],
            },
          },
          'widget.ProductGrid.productBackgroundType': {
            type: 'ToggleRadioTabs',
            order: 8,
            renderOptions: {
              controlKey: 'productBackgroundType',
              direction: 'row',
            },
            options: {
              productBackgroundImage: {
                type: 'ImageUploader',
              },
              productBackgroundColor: {
                type: 'HexColor',
              },
            },
          },
          productImagePadding: {
            order: 9,
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
          },
          productImageBorderRadius: {
            order: 10,
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
          },
          productImageHeight: {
            order: 11,
            data: {
              max: 250,
              min: 80,
              step: 1,
            },
            type: 'RangePx',
          },
          productBorderColor: {
            order: 6,
            type: 'HexColor',
          },
        },
      },
      Menu_ProductNameSettings: {
        type: 'Menu',
        order: 201,
        renderOptions: {
          controlKey: 'ProductNameSettings',
        },
        options: {
          productTextWeight: {
            order: 61,
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
          },
          productTextControl: {
            order: 62,
            data: {
              direction: 'row',
              radioOptions: ['clip', 'double', 'wrap'],
            },
            type: 'Radio',
          },
          productTextAlignment: {
            order: 63,
            type: 'LeftCenterRight',
          },
          productTextColor: {
            order: 64,
            type: 'HexColor',
          },
          productTextSize: {
            order: 65,
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
        },
      },
      Menu_FavoriteSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'favoriteSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isHeartIcon',
            },
            options: {
              heartIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 17,
              },
              heartIconBackgroundColor: {
                type: 'HexColor',
                order: 18,
              },
              heartIconColor: {
                type: 'HexColor',
                order: 19,
              },
              selectedHeartIconColor: {
                type: 'HexColor',
                order: 20,
              },
              heartIconWidth: {
                order: 21,
                data: {
                  max: 32,
                  min: 12,
                  step: 1,
                },
                type: 'RangePx',
              },
              heartIconBorderRadius: {
                order: 22,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_CartSettings: {
        type: 'Menu',
        order: 400,
        renderOptions: {
          controlKey: 'cartSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isCartIcon',
            },
            options: {
              cartIconText: {
                type: 'Text',
                order: 22,
              },
              cartIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 24,
              },
              cartIconLocation: {
                type: 'Radio',
                order: 23,
                data: {
                  direction: 'row',
                  radioOptions: ['bottom', 'top'],
                },
              },
              cartIconBackgroundColor: {
                type: 'HexColor',
                order: 25,
              },
              cartIconColor: {
                type: 'HexColor',
                order: 26,
              },
              cartIconWidth: {
                order: 27,
                data: {
                  max: 32,
                  min: 12,
                  step: 1,
                },
                type: 'RangePx',
              },
              cartIconBorderRadius: {
                order: 28,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
              cartIconBorderColor: {
                type: 'HexColor',
                order: 29,
              },
              cartIconPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
                order: 30,
              },
              cartIconMarginTop: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'RangePx',
                order: 31,
              },
            },
          },
        },
      },
      Menu_DiscountSettings: {
        type: 'Menu',
        order: 500,
        renderOptions: {
          controlKey: 'discountSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isDiscountIcon',
            },
            options: {
              discountIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 30,
              },
              discountText: {
                type: 'Text',
                order: 31,
              },
              discountTextAlignment: {
                type: 'Radio',
                order: 32,
                data: {
                  direction: 'row',
                  radioOptions: ['row', 'column'],
                },
              },

              discountIconBackgroundColor: {
                type: 'HexColor',
                order: 33,
              },
              discountIconColor: {
                type: 'HexColor',
                order: 33,
              },
              discountIconWidth: {
                order: 34,
                data: {
                  max: 20,
                  min: 0,
                  step: 1,
                },
                type: 'RangePx',
              },
              discountIconBorderRadius: {
                order: 35,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
              discountIconPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_TagSettings: {
        type: 'Menu',
        order: 550,
        renderOptions: {
          controlKey: 'tagSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isTagArea',
            },
            options: {
              tagIdText: {
                type: 'Text',
                order: 1,
              },
              tagImage: {
                type: 'ImageUploader',
              },
              tagImageWidth: {
                order: 34,
                data: {
                  max: 80,
                  min: 0,
                  step: 1,
                },
                type: 'RangePx',
              },
            },
          },
        },
      },
      Menu_VariantSettings: {
        type: 'Menu',
        order: 600,
        renderOptions: {
          controlKey: 'VariantSettings',
        },
        options: {
          colorBoxBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 41,
          },
          colorBoxBackgroundColor: {
            type: 'HexColor',
            order: 42,
          },
          colorBoxColorsBorderColor: {
            type: 'HexColor',
            order: 43,
          },
        },
      },
      Menu_ProductFrameSettings: {
        type: 'Menu',
        order: 700,
        renderOptions: {
          controlKey: 'ProductFrameSettings',
        },
        options: {
          borderColor: {
            type: 'HexColor',
            order: 41,
          },
          betweenProductAndBorderPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 42,
          },
        },
      },
      Menu_ProductStarSettings: {
        type: 'Menu',
        order: 800,
        renderOptions: {
          controlKey: 'ProductStarSettings',
        },
        options: {
          isShowStar: {
            type: 'Radio',
            order: 51,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          starSize: {
            type: 'RangePx',
            data: {
              max: 36,
              min: 6,
              step: 1,
            },
            order: 52,
          },
        },
      },
      Menu_ProductPriceSettings: {
        type: 'Menu',
        order: 1000,
        renderOptions: {
          controlKey: 'ProductPriceSettings',
        },
        options: {
          productPriceTextAlign: {
            order: 71,
            data: {
              direction: 'row',
              radioOptions: ['row', 'column'],
            },
            type: 'Radio',
          },
          productPriceTextSize: {
            order: 72,
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          productPriceWeight: {
            order: 73,
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
          },
          productPriceColor: {
            order: 74,
            type: 'HexColor',
          },
          productDiscountPriceTextSize: {
            order: 75,
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          productDiscountPriceWeight: {
            order: 76,
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
          },
          productDiscountPriceColor: {
            order: 77,
            type: 'HexColor',
          },
          useCurrencyCode: {
            order: 78,
            type: 'Toggle',
          },
        },
      },
      Menu_BrandNameSettings: {
        type: 'Menu',
        order: 1100,
        renderOptions: {
          controlKey: 'BrandNameSettings',
        },
        options: {
          isShowBrandName: {
            type: 'Radio',
            order: 81,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          brandNameTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 82,
          },
          brandNameTextColor: {
            type: 'HexColor',
            order: 83,
          },
          brandNameTextAlignment: {
            type: 'LeftCenterRight',
            order: 84,
          },
          brandNameTextControl: {
            data: {
              direction: 'row',
              radioOptions: ['clip', 'double', 'wrap'],
            },
            type: 'Radio',
            order: 85,
          },
          brandNameTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 86,
          },
          brandNameTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 87,
          },
          brandNameTextDecoration: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'underline', 'line-through'],
            },
            order: 88,
          },
        },
      },
      Menu_OtherProductCartSettings: {
        type: 'Menu',
        order: 1101,
        renderOptions: {
          controlKey: 'OtherProductCartSettings',
        },
        options: {
          isShowOtherProductCartSettings: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          otherProductCartSettingsText: {
            type: 'Text',
            order: 1,
          },
          otherProductCartSettingsTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 82,
          },
          otherProductCartSettingsTextColor: {
            type: 'HexColor',
            order: 83,
          },
          otherProductCartSettingsTextAlignment: {
            type: 'LeftCenterRight',
            order: 84,
          },
          otherProductCartSettingsTextControl: {
            data: {
              direction: 'row',
              radioOptions: ['clip', 'double', 'wrap'],
            },
            type: 'Radio',
            order: 85,
          },
          otherProductCartSettingsTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 86,
          },
          otherProductCartSettingsTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 87,
          },
        },
      },
      Menu_IndicatorSettings: {
        type: 'Menu',
        order: 1200,
        renderOptions: {
          controlKey: 'IndicatorSettings',
        },
        options: {
          isShowIndicator: {
            type: 'Radio',
            order: 301,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          indicatorType: {
            type: 'Radio',
            order: 302,
            data: {
              direction: 'row',
              radioOptions: ['circle', 'row'],
            },
          },
        },
      },
      Menu_ColorVariantSettings: {
        type: 'Menu',
        order: 1250,
        renderOptions: {
          controlKey: 'ColorVariantSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isColorVariantIcons',
            },
            options: {
              colorVariantIconWidth: {
                order: 34,
                data: {
                  max: 20,
                  min: 0,
                  step: 1,
                },
                type: 'RangePx',
              },
              colorVariantIconBorderRadius: {
                order: 35,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
          'widget.ToggleTabs_2': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isColorVariantText',
            },
            options: {
              colorVariantTextSize: {
                type: 'RangePx',
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                },
                order: 1,
              },
              colorVariantTextColor: {
                type: 'HexColor',
                order: 2,
              },
              colorVariantTextStyle: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['normal', 'italic'],
                },
                order: 3,
              },
              colorVariantTextWeight: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                },
                order: 4,
              },
            },
          },
        },
      },
      Menu_BottomRightTagSettings: {
        type: 'Menu',
        order: 1260,
        renderOptions: {
          controlKey: 'BottomRightTagSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isBottomRightTagSettings',
            },
            options: {
              bottomRightTagSettingsPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              bottomRightTagSettingsBorderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
              bottomRightTagSettingsTextSize: {
                type: 'RangePx',
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                },
                order: 1,
              },
              bottomRightTagSettingsTextColor: {
                type: 'HexColor',
                order: 2,
              },
              bottomRightTagSettingsBackgroundColor: {
                type: 'HexColor',
                order: 2,
              },
              bottomRightTagSettingsTextStyle: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['normal', 'italic'],
                },
                order: 3,
              },
              bottomRightTagSettingsTextWeight: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                },
                order: 4,
              },
            },
          },
        },
      },
      Menu_BottomLeftTagSettings: {
        type: 'Menu',
        order: 1270,
        renderOptions: {
          controlKey: 'BottomLeftTagSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isBottomLeftTagSettings',
            },
            options: {
              bottomLeftTagSettingsPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              bottomLeftTagSettingsBorderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
              bottomLeftTagSettingsTextSize: {
                type: 'RangePx',
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                },
                order: 1,
              },
              bottomLeftTagSettingsTextColor: {
                type: 'HexColor',
                order: 2,
              },
              bottomLeftTagSettingsBackgroundColor: {
                type: 'HexColor',
                order: 2,
              },
              bottomLeftTagSettingsTextStyle: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['normal', 'italic'],
                },
                order: 3,
              },
              bottomLeftTagSettingsTextWeight: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                },
                order: 4,
              },
            },
          },
        },
      },
      Menu_GeneralSettings: {
        type: 'Menu',
        order: 1300,
        renderOptions: {
          controlKey: 'OtherSettings',
        },
        options: {
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 13,
            options: {
              containerPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              padding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              borderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
          'widget.ToggleRadioTabs_1': {
            type: 'ToggleRadioTabs',
            order: 14,
            renderOptions: {
              controlKey: 'backgroundType',
              direction: 'row',
            },
            options: {
              backgroundImage: {
                type: 'ImageUploader',
              },
              backgroundColor: {
                type: 'HexColor',
              },
            },
          },
          productDetailBackgroundColor: {
            type: 'HexColor',
            order: 15,
          },
          productTitleMarginBottom: {
            type: 'RangePx',
            order: 16,
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          boxShadow: {
            type: 'ChildComponentRenderer',
            order: 26,
            data: {
              componentNames: ['shadow1', 'shadow2', 'shadow3'],
            },
          },
          isShowLimitedStock: {
            type: 'Radio',
            order: 17,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'ProductSlider_1',
      name: 'ProductSlider_1',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '14px',
        textColor: '#292929',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '7px 0px 7px 4px',
        padding: '4px 4px 4px 4px',
        borderRadius: '6px 6px 6px 6px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        productTextControl: 'clip',
        productTextWeight: '600',
        productTextColor: '#292929',
        productTextSize: '10px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '118px',
        dynamicHeight: true,
        productBackgroundImage: '',
        productBackgroundType: '-',
        productBorderColor: '#5c5c5c',
        productPriceTextSize: '9px',
        productPriceWeight: '500',
        productPriceColor: '#000000',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#212121',
        selectedHeartIconColor: '#979191',
        heartIconWidth: '12px',
        heartIconBorderRadius: '40px 40px 40px 40px',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#66b356',
        discountIconColor: '#3b3b3b',
        discountIconWidth: '12px',
        discountIconBorderRadius: '0px 0px 7px 7px',
        isCartIcon: true,
        cartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1724939608358.png',
        cartIconBackgroundColor: '#f1f1f1',
        cartIconColor: '#292929',
        cartIconWidth: '12px',
        cartIconBorderRadius: '40px 40px 40px 40px',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
        borderColor: '#363636',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productDiscountPriceTextSize: '10px',
        productDiscountPriceWeight: '400',
        productDiscountPriceColor: '#000000',
        productDetailBackgroundColor: '#FFFFFF',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_2',
      name: 'ProductSlider_2',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '14px',
        textColor: '#292929',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '10px 0px 10px 5px',
        padding: '4px 4px 4px 4px',
        borderRadius: '7px 7px 7px 7px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        productTextControl: 'double',
        productTextWeight: '600',
        productTextColor: '#292929',
        productTextSize: '11px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '118px',
        dynamicHeight: true,
        productBackgroundImage: '',
        productBackgroundType: '-',
        productBorderColor: '#5c5c5c00',
        productPriceTextSize: '9px',
        productPriceWeight: '500',
        productPriceColor: '#000000',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#212121',
        selectedHeartIconColor: '#979191',
        heartIconWidth: '12px',
        heartIconBorderRadius: '40px 40px 40px 40px',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#66b356',
        discountIconColor: '#ffffff',
        discountIconWidth: '12px',
        discountIconBorderRadius: '0px 0px 6px 6px',
        isCartIcon: true,
        cartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1724939608358.png',
        cartIconBackgroundColor: '#ffffff',
        cartIconColor: '#292929',
        cartIconWidth: '14px',
        cartIconBorderRadius: '40px 40px 40px 40px',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
        borderColor: '#363636',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productDiscountPriceTextSize: '10px',
        productDiscountPriceWeight: '400',
        productDiscountPriceColor: '#000000',
        productPriceTextAlign: 'row',
        discountText: 'indirim',
        isShowStar: 'show',
        starSize: '15px',
        productDetailBackgroundColor: '#FFFFFF',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/ProductSlider_2.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_3',
      name: 'ProductSlider_3',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+3.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_4',
      name: 'ProductSlider_4',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+4.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_5',
      name: 'ProductSlider_5',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+5.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_6',
      name: 'ProductSlider_6',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+6.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_7',
      name: 'ProductSlider_7',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+7.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_8',
      name: 'ProductSlider_8',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+8.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_9',
      name: 'ProductSlider_9',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+9.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_10',
      name: 'ProductSlider_10',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+10.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_11',
      name: 'ProductSlider_11',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+11.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_12',
      name: 'ProductSlider_12',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+12.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_13',
      name: 'ProductSlider_13',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+13.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_14',
      name: 'ProductSlider_14',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+14.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_15',
      name: 'ProductSlider_15',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+15.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_16',
      name: 'ProductSlider_16',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+16.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_17',
      name: 'ProductSlider_17',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+17.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_18',
      name: 'ProductSlider_18',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+18.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'ProductSlider_19',
      name: 'ProductSlider_19',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '14px',
        textColor: '#292929',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '10px 0px 10px 5px',
        padding: '4px 4px 4px 4px',
        borderRadius: '6px 6px 6px 6px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        productTextControl: 'double',
        productTextWeight: '600',
        productTextColor: '#292929',
        productTextSize: '8px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '160px',
        dynamicHeight: true,
        productBackgroundImage: '',
        productBackgroundType: '-',
        productBorderColor: '#e74040',
        productPriceTextSize: '8px',
        productPriceWeight: '500',
        productPriceColor: '#000000',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
        borderColor: '#363636',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productDiscountPriceTextSize: '10px',
        productDiscountPriceWeight: '400',
        productDiscountPriceColor: '#000000',
        productPriceTextAlign: 'row',
        productDetailBackgroundColor: '#FFFFFF',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#E12323',
        discountIconColor: '#FFFFFF',
        discountIconWidth: '10px',
        discountIconBorderRadius: '8px 8px 8px 8px',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#050505',
        selectedHeartIconColor: '#ff0000',
        heartIconWidth: '20px',
        heartIconBorderRadius: '40px 40px 40px 40px',
        isColorVariantIcons: true,
        colorVariantIconWidth: '10px',
        colorVariantIconBorderRadius: '30px 30px 30px 30px',
        isColorVariantText: true,
        colorVariantTextSize: '12px',
        colorVariantTextColor: '#000000',
        colorVariantTextStyle: 'normal',
        colorVariantTextWeight: '400',
        isBottomRightTagSettings: true,
        bottomRightTagSettingsPadding: '2px 8px 2px 8px',
        bottomRightTagSettingsBorderRadius: '8px 8px 8px 8px',
        bottomRightTagSettingsTextSize: '10px',
        bottomRightTagSettingsTextColor: '#000000',
        bottomRightTagSettingsBackgroundColor: '#FFFFFF',
        bottomRightTagSettingsTextStyle: 'normal',
        bottomRightTagSettingsTextWeight: '500',
        isBottomLeftTagSettings: true,
        bottomLeftTagSettingsPadding: '2px 8px 2px 8px',
        bottomLeftTagSettingsBorderRadius: '8px 8px 8px 8px',
        bottomLeftTagSettingsTextSize: '10px',
        bottomLeftTagSettingsTextColor: '#E12323',
        bottomLeftTagSettingsBackgroundColor: '#FFFFFF',
        bottomLeftTagSettingsTextStyle: 'normal',
        bottomLeftTagSettingsTextWeight: '500',
        discountIconPadding: '2px 8px 2px 8px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/productSlider_19.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_20',
      name: 'ProductSlider_20',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '14px',
        textColor: '#292929',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '10px 0px 10px 5px',
        padding: '4px 4px 4px 4px',
        borderRadius: '0px 0px 0px 0px',
        boxShadow: false,
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        productTextControl: 'clip',
        productTextWeight: '600',
        productTextColor: '#292929',
        productTextSize: '10px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '160px',
        dynamicHeight: true,
        productBackgroundImage: '',
        productBackgroundType: '-',
        productPriceTextSize: '9px',
        productPriceWeight: '500',
        productPriceColor: '#000000',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#000000',
        selectedHeartIconColor: '#5e5e5e',
        heartIconWidth: '13px',
        heartIconBorderRadius: '40px 40px 40px 40px',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#66b356',
        discountIconColor: '#ffffff',
        discountIconWidth: '12px',
        discountIconBorderRadius: '0px 0px 0px 0px',
        isCartIcon: true,
        cartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1724945164605.png',
        cartIconBackgroundColor: '#ffffff',
        cartIconColor: '#000000',
        cartIconWidth: '13px',
        cartIconBorderRadius: '40px 40px 40px 40px',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
        borderColor: '#000000',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productBorderColor: '#ffffff',
        productDiscountPriceTextSize: '10px',
        productDiscountPriceWeight: '400',
        productDiscountPriceColor: '#000000',
        productPriceTextAlign: 'row',
        discountText: 'indirim',
        isShowStar: 'show',
        starSize: '15px',
        productDetailBackgroundColor: '#FFFFFF',
        isShowLimitedStock: 'show',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/ProductSlider_20.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_21',
      name: 'ProductSlider_21',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '12px',
        textColor: '#2e2e2e',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '6px 6px 6px 6px',
        padding: '5px 5px 5px 5px',
        borderRadius: '0px 0px 0px 0px',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        productTextControl: 'clip',
        productTextWeight: '400',
        productTextColor: '#000000',
        productTextSize: '10px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '168px',
        productBackgroundImage: '',
        productBackgroundType: '-',
        productPriceTextSize: '8px',
        productPriceWeight: '500',
        productPriceColor: '#000000',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#050505',
        selectedHeartIconColor: '#ff0000',
        heartIconWidth: '12px',
        heartIconBorderRadius: '40px 40px 40px 40px',
        isDiscountIcon: true,
        discountIconColor: '#f20707',
        discountIconWidth: '10px',
        isCartIcon: true,
        cartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1724947361642.png',
        cartIconBackgroundColor: '#ffffff',
        cartIconColor: '#050505',
        cartIconWidth: '12px',
        cartIconBorderRadius: '40px 40px 40px 40px',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
        borderColor: '#ffffff',
        productTextAlignment: 'left',
        productTitleMarginBottom: '5px',
        productBorderColor: '#ffffff',
        productDiscountPriceTextSize: '10px',
        productDiscountPriceWeight: '400',
        productDiscountPriceColor: '#000000',
        productPriceTextAlign: 'row',
        isShowBrandName: 'show',
        brandNameTextAlignment: 'left',
        brandNameTextSize: '12px',
        brandNameTextColor: '#000000',
        brandNameTextStyle: 'normal',
        brandNameTextWeight: '700',
        brandNameTextControl: 'clip',
        colorBoxBorderRadius: '0px 0px 0px 0px',
        colorBoxBackgroundColor: '#ffffff',
        colorBoxColorsBorderColor: '#e4e3e1',
        isShowIndicator: 'show',
        indicatorType: 'circle',
        productDetailBackgroundColor: '#FFFFFF',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/ProductSlider_21.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_22',
      name: 'ProductSlider_22',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '12px',
        textColor: '#2e2e2e',
        textStyle: 'normal',
        textWeight: '400',
        containerPadding: '6px 6px 6px 6px',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        padding: '7px 7px 7px 7px',
        borderRadius: '5px 5px 5px 5px',
        boxShadow: 'shadow1',
        backgroundSize: 'cover',
        productTextControl: 'double',
        productTextWeight: '500',
        productTextColor: '#000000',
        productTextSize: '11px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '135px',
        productBackgroundImage: '',
        productBackgroundType: '-',
        productPriceTextSize: '11px',
        productPriceWeight: '500',
        productPriceColor: '#292929',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#E7006A',
        discountIconColor: '#FFFFFF',
        discountIconWidth: '10px',
        discountIconBorderRadius: '5px 5px 5px 5px',
        isCartIcon: true,
        cartIconBackgroundColor: '#E7006A',
        cartIconColor: '#FFFFFF',
        cartIconWidth: '14px',
        cartIconBorderRadius: '5px 5px 5px 5px',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
        borderColor: '#FFFFFF',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productDiscountPriceTextSize: '9px',
        productDiscountPriceWeight: '500',
        productDiscountPriceColor: '#818181',
        productDetailBackgroundColor: '#FFFFFF',
        isShowStar: 'show',
        starSize: '10px',
        isShowBrandName: 'show',
        brandNameTextAlignment: 'left',
        brandNameTextSize: '12px',
        brandNameTextColor: '#909193',
        brandNameTextStyle: 'normal',
        brandNameTextWeight: '500',
        brandNameTextControl: 'clip',
        otherProductCartSettingsText: 'Üyelerimize Özel!',
        isShowOtherProductCartSettings: 'show',
        otherProductCartSettingsTextAlignment: 'left',
        otherProductCartSettingsTextSize: '8px',
        otherProductCartSettingsTextColor: '#E7006A',
        otherProductCartSettingsTextStyle: 'normal',
        otherProductCartSettingsTextWeight: '500',
        otherProductCartSettingsTextControl: 'clip',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#050505',
        selectedHeartIconColor: '#ff0000',
        heartIconWidth: '13px',
        heartIconBorderRadius: '40px 40px 40px 40px',
        cartIconLocation: 'bottom',
        discountText: 'Kazancınız',
        useCurrencyCode: false,
        discountBoxPadding: '5px 5px 5px 5px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/ProductSlider_22.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_23',
      name: 'ProductSlider_23',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '14px',
        textColor: '#292929',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '6px 6px 6px 6px',
        padding: '5px 5px 5px 5px',
        borderRadius: '6px 6px 6px 6px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        productTextControl: 'double',
        productTextWeight: '500',
        productTextColor: '#000000',
        productTextSize: '12px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '118px',
        productBackgroundImage: '',
        productBackgroundType: '-',
        productBorderColor: '#333333',
        productPriceTextSize: '12px',
        productPriceWeight: '600',
        productPriceColor: '#292929',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#F04F36',
        discountIconColor: '#FFFFFF',
        discountIconWidth: '8px',
        discountIconBorderRadius: '2px 2px 2px 2px',
        isCartIcon: true,
        cartIconBackgroundColor: '#21AAE2',
        cartIconColor: '#FFFFFF',
        cartIconWidth: '12px',
        cartIconBorderRadius: '4px 4px 4px 4px',
        betweenProductAndBorderPadding: '4px 4px 4px 4px',
        borderColor: '#000000',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productDiscountPriceTextSize: '9px',
        productDiscountPriceWeight: '500',
        productDiscountPriceColor: '#6e6e6e',
        productDetailBackgroundColor: '#FFFFFF',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Product+Carousel+Slider+1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_24',
      name: 'ProductSlider_24',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'left',
        textSize: '10px',
        textColor: '#000000',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 4px 8px',
        borderRadius: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        productTextControl: 'clip',
        productTextWeight: '400',
        productTextColor: '#000000',
        productTextSize: '10px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '168px',
        productBackgroundImage: '',
        productBackgroundType: '-',
        productBorderColor: '#000000',
        productPriceTextSize: '10px',
        productPriceWeight: '500',
        productPriceColor: '#000000',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
        borderColor: '#FFFFFF',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productDiscountPriceTextSize: '9px',
        productDiscountPriceWeight: '400',
        productDiscountPriceColor: '#000000',
        productPriceTextAlign: 'column',
        productDetailBackgroundColor: '#FFFFFF',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#E12323',
        discountIconColor: '#FFFFFF',
        discountIconWidth: '8px',
        discountIconBorderRadius: '0px 0px 0px 0px',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconColor: '#050505',
        selectedHeartIconColor: '#ff0000',
        heartIconWidth: '14px',
        heartIconBorderRadius: '0px 0px 0px 0px',
        discountIconPadding: '2px 8px 2px 8px',
        discountText: '',
        discountTextAlignment: 'row',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/productSlider_19.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_25',
      name: 'ProductSlider_25',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {},
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/productSlider_19.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_26',
      name: 'ProductSlider_26',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '14px',
        textColor: '#292929',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        textLetterSpacing: '0px',
        containerPadding: '6px 6px 6px 6px',
        padding: '5px 5px 5px 5px',
        borderRadius: '6px 6px 6px 6px',
        boxShadow: 'shadow1',
        backgroundSize: 'cover',
        productTextControl: 'double',
        productTextWeight: '500',
        productTextColor: '#000000',
        productTextSize: '12px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '150px',
        productBackgroundImage: '',
        productBackgroundType: '-',
        productBorderColor: '#FFFFFF',
        productPriceTextSize: '12px',
        productPriceWeight: '600',
        productPriceColor: '#292929',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#F04F36',
        discountIconColor: '#FFFFFF',
        discountIconWidth: '12px',
        discountIconBorderRadius: '2px 2px 2px 2px',
        isCartIcon: true,
        cartIconBackgroundColor: '#FFFFFF',
        cartIconColor: '#000000',
        cartIconWidth: '12px',
        cartIconBorderRadius: '4px 4px 4px 4px',
        betweenProductAndBorderPadding: '4px 4px 4px 4px',
        borderColor: '#FFFFFF',
        productTextAlignment: 'left',
        productTitleMarginBottom: '5px',
        productDiscountPriceTextSize: '12px',
        productDiscountPriceWeight: '500',
        productDiscountPriceColor: '#6e6e6e',
        productDetailBackgroundColor: '#FFFFFF',
        isTagArea: true,
        tagIdText: '',
        tagImage: 'https://d9aff4nz0lkg0.cloudfront.net/discount_image.webp',
        tagImageWidth: '35px',
        cartIconBorderColor: '#000000',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/productSlider_19.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ProductSlider_28',
      name: 'ProductSlider_28',
      type: 'ProductSlider',
      data: {
        text: '',
        images: [],
        dynamicImages: [],
        isDynamic: false,
      },
      customization: {
        textAlignment: 'center',
        textSize: '14px',
        textColor: '#292929',
        textStyle: 'normal',
        textWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        textLetterSpacing: '0px',
        containerPadding: '6px 6px 6px 6px',
        padding: '5px 5px 5px 5px',
        borderRadius: '6px 6px 6px 6px',
        boxShadow: 'shadow1',
        backgroundSize: 'cover',
        productTextWeight: '500',
        productTextColor: '#000000',
        productTextSize: '12px',
        productBackgroundColor: '#F0EEFB',
        productImagePadding: '0px 0px 0px 0px',
        productImageBorderRadius: '0px 0px 0px 0px',
        productImageHeight: '190px',
        productBackgroundImage: '',
        productBackgroundType: '-',
        productPriceTextSize: '12px',
        productPriceWeight: '600',
        productPriceColor: '#292929',
        isDiscountIcon: true,
        discountIconBackgroundColor: '#F04F36',
        discountIconColor: '#FFFFFF',
        discountIconWidth: '9px',
        discountIconBorderRadius: '2px 2px 2px 2px',
        isCartIcon: true,
        cartIconBackgroundColor: '#027BBD',
        cartIconColor: '#FFFFFF',
        cartIconWidth: '12px',
        cartIconBorderRadius: '40px 40px 40px 40px',
        betweenProductAndBorderPadding: '4px 4px 4px 4px',
        borderColor: '#FFFFFF',
        productTextAlignment: 'left',
        productTitleMarginBottom: '0px',
        productDiscountPriceTextSize: '12px',
        productDiscountPriceWeight: '500',
        productDiscountPriceColor: '#6e6e6e',
        productDetailBackgroundColor: '#FFFFFF',
        isTagArea: false,
        tagIdText: '',
        tagImage: 'https://d9aff4nz0lkg0.cloudfront.net/discount_image.webp',
        tagImageWidth: '35px',
        cartIconBorderColor: '#027BBD',
        cartIconPadding: '5px 8px 5px 8px',
        cartIconMarginTop: '5px',
        cartIconText: 'Add',
        discountText: 'MEMBERS SAVE',

        isShowBrandName: 'show',
        brandNameTextAlignment: 'left',
        brandNameTextSize: '12px',
        brandNameTextColor: '#000000',
        brandNameTextStyle: 'normal',
        brandNameTextWeight: '500',
        brandNameTextControl: 'clip',
        brandNameTextDecoration: 'underline',
        isShowStar: 'show',
        starSize: '15px',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/productSlider_19.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};
export default ProductSlider;
